/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2022 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */

import React, {useState} from 'react';
import {ReactComponent as Email} from "../../assets/img/forms/email.svg";
import {ReactComponent as Eye} from "../../assets/img/forms/eye.svg";
import {ReactComponent as ArrowRight} from "../../assets/img/icons/arrow-right-white.svg";
import {useForm} from "react-hook-form";
import {useAuth} from "../../Hooks/useAuth";
import useAxiosJTW from "../../Hooks/useAxiosJTW";
import {Link, useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import LoginModal from "../../components/LoginModal";

const LoginForm = (props) => {

    const [showPass, setShowPass] = useState(false);
    const [error, setError] = useState(false);

    const user = useAuth();
    const { t, i18n } = useTranslation();
    const axiosJWT = useAxiosJTW();

    const { control, register, handleSubmit, watch, reset, formState: { errors }, trigger, clearErrors } = useForm({
        mode: "onChange",
    });

    function toggleShow(){
        setShowPass(v => !v);
    }

    const userLogin = (data, signal) => {
        setError(false);
        axiosJWT.post('api/getusertoken', { email: data.email, password: data.password }, {signal}).then( (response) => {
            if(response.status === 200){
                if(response.data.success){
                    user.logIn({
                        email: data.email,
                        user_id: response.data.user_id,
                        group_id: response.data.group_id,
                        fname: response.data.fname,
                        lname: response.data.lname,
                        phone: response.data.phone,
                        userToken: response.data.user_token
                    });
                    // group_id :2 -> admin
                    // group_id :3 -> merchant
                    // group_id :4 -> user
                    props.onComplete(response);
                    reset();
                }
                else{
                    setError(true);
                }
            }
        } ).catch((error) => {
            console.log(error);
            setError(true);
        });
    }

    const onSubmit = data => {
        const controller = new AbortController();
        const signal= controller.signal;

        userLogin(data, signal);

        return () => {controller.abort();}
    };

    return (
        <form className='login-form' onSubmit={handleSubmit(onSubmit)}>

            <div className="form-group">
                <label htmlFor='loginEmail'>{t('fields.email')}</label>
                <div className='form-group__wrap'>
                    <input id='loginEmail' className="form-control" type="email" {...register("email",{required: `${t('fields.requiredfield')}`} )} placeholder={t('fields.emailPlace')}/>
                    <span className='form-group__icon'><Email/></span>
                </div>
                { errors.email && <small className="text-danger">{errors.email?.message}</small>}
            </div>

            <div className="form-group">
                <label htmlFor='loginPassword'>{t('fields.password')} </label>
                <div className='form-group__wrap'>
                    <input id='loginPassword' className="form-control" type={showPass ? "text" : "password"} {...register("password",{required: `${t('fields.requiredfield')}`} )} placeholder={t('fields.passPlace')}/>
                    <span className='form-group__icon form-group__icon--password' onClick={toggleShow}>
                        {!showPass
                            ? <span className='icon--opened'><Eye/></span>
                            : <span className='icon--closed'><Eye/></span>
                        }
                        </span>
                </div>
                { errors.password && <small className="text-danger">{errors.password?.message}</small>}
            </div>

            <div className="form-group mb-4">
                {/*<label className="custom-checkbox">*/}
                {/*    <input type="checkbox" {...register("remember" )}/>*/}
                {/*    <span className="custom-checkbox__icon custom-checkbox__empty"><CheckboxEmpty/></span>*/}
                {/*    <span className="custom-checkbox__icon custom-checkbox__checked"><CheckboxFull/></span>*/}
                {/*    Remember me*/}
                {/*</label>*/}
                {/*{ errors.remember && <small className="form-error text-danger">{errors.remember?.message}</small>}*/}
            </div>

            <button type="submit" className='btn btn-primary btn-icon btn-icon-right btn-block'>{t('login.loginButton')}<ArrowRight/></button>

            {error && <div className="text-danger pt-3">{t('login.incorectpassoruser')}</div>}

            {user.profile.isLogged
                ? <div className='pt-4'>
                    <div className="alert alert-success" role="alert">
                        {t('login.succesfullylogged')}
                    </div>
                </div>
                : <div className='py-3'>
                    <Link to={`/${i18n.language}/forgot-password`} className='forgot-pass dis'>{t('fields.forgotPassword')}</Link>
                </div>
            }

            <div className=''>
                <Link to={`/${i18n.language}/register`} className='register-link'>{t('login.createAccount')}</Link>
            </div>

        </form>
    );
};

export default LoginForm;